/* RESPONSIBLE TEAM: team-inbox */
export enum InboxCategory {
  Shared = 'shared',
  Admin = 'admin',
  Team = 'team',
  View = 'view',
  Dashboard = 'dashboard',
}
